import { FeatureTypes } from '@/components/Billing/billing-types';

const ALL_INBOX_ID = 'all';
const SHARED_INBOX_ID = 'shared';
const PRIVATE_INBOX_ID = 'private';
export const STATIC_INBOXES_IDS = { ALL_INBOX_ID, SHARED_INBOX_ID, PRIVATE_INBOX_ID };
export const staticInboxes = [
	{ name: 'All', localIcon: 'all-inbox', id: STATIC_INBOXES_IDS.ALL_INBOX_ID },
	{ name: 'Private inbox', localIcon: 'private-inbox', id: STATIC_INBOXES_IDS.PRIVATE_INBOX_ID },
	{
		name: 'Shared inbox',
		localIcon: 'shared-inbox',
		id: STATIC_INBOXES_IDS.SHARED_INBOX_ID,
		billingFeatureId: FeatureTypes.SharedNotificationInboxes,
	},
];
